module.exports = __webpack_public_path__ + "img/waterpurifier33.858fc513.jpg";